module.exports = __webpack_public_path__ + "img/cloudFaq1.6ba8dd42.png";